import { ReactNode } from "react";

export default function PageHero({
  desktop,
  mobile,
  alt,
  children,
  heightClass = "min-h-[480px] md:min-h-[560px]",
  focus = "50% 25%",
}: {
  desktop: string;
  mobile: string;
  alt: string;
  children: ReactNode;
  heightClass?: string;
  focus?: string;
}) {
  return (
    <section className={`relative w-full overflow-hidden flex items-end ${heightClass}`}>
      <picture className="absolute inset-0 block h-full w-full">
        <source media="(min-width: 768px)" srcSet={desktop} />
        <img
          src={mobile}
          alt={alt}
          className="h-full w-full object-cover"
          style={{ objectPosition: focus }}
          fetchPriority="high"
          decoding="async"
        />
      </picture>
      <div className="nm-grain absolute inset-0" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#041333]/92 via-[#071a43]/35 to-transparent" />
      <div className="absolute inset-0 bg-gradient-to-t from-[var(--nm-bg)] via-[var(--nm-bg)]/15 to-black/5" />
      <div className="absolute bottom-0 inset-x-0 nm-gold-rule" />
      <div className="nm-container relative pt-24 pb-10 md:pt-28 md:pb-14 w-full">
        {children}
      </div>
    </section>
  );
}
